import type { CombinedError } from "@urql/core"
import { mapExchange } from "@urql/core"

import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

export const NETWORK_ERROR_MESSAGE = "Can't reach the server. Check your internet connection and try again."

const DEDUPE_WINDOW_MS = 5000

let lastNotifiedAt = 0

export const resetNetworkErrorThrottle = (): void => {
  lastNotifiedAt = 0
}

export const handleNetworkError = (error: CombinedError): void => {
  if (!error.networkError) {
    return
  }

  const now = Date.now()
  if (now - lastNotifiedAt < DEDUPE_WINDOW_MS) {
    return
  }
  lastNotifiedAt = now

  useNotificationsStore.getState().enqueueNotification({
    type: NotificationType.Error,
    message: NETWORK_ERROR_MESSAGE,
  })
}

export const networkErrorExchange = mapExchange({
  onError(error) {
    handleNetworkError(error)
  },
})
